<section class="ig-banner-blog" aria-label="Consejos para tu mascota">
  <div class="ig-banner-blog__imagen" [style.background-image]="'url(\'' + imagen + '\')'" role="img" aria-label="Persona chocando la mano con un perro"></div>
  <div class="ig-banner-blog__contenido">
    <h2>{{ titulo }}</h2>
    <p>{{ descripcion }}</p>
    <a class="ig-banner-blog__boton" [href]="url">
      <span>{{ textoBoton }}</span>
      <i class="fa-solid fa-arrow-right" aria-hidden="true"></i>
    </a>
    <span class="ig-banner-blog__rayas" aria-hidden="true"><i></i><i></i><i></i></span>
  </div>
  <svg class="ig-banner-blog__corazon" viewBox="0 0 46 52" fill="none" aria-hidden="true">
    <path d="M22 45C15 33 4 29 5 18C5 7 17 5 23 21C29 6 41 7 41 18C41 30 30 39 22 45Z" stroke="currentColor" stroke-width="3" stroke-linejoin="round" stroke-linecap="round"/>
  </svg>
</section>
